import React from 'react';
import { HeroVariant51 } from '../components/HeroVariant51';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage51() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1690">
      <Navigation data-id="element-1691" />
      <main data-id="element-1692">
        <HeroVariant51 data-id="element-1693" />
        <WhyUs data-id="element-1694" />
        <Services data-id="element-1695" />
        <FAQ data-id="element-1696" />
        <Testimonials data-id="element-1697" />
        <Consultation data-id="element-1698" />
      </main>
      <Footer data-id="element-1699" />
      <CookieBanner data-id="element-1700" />
      <FloatingContact data-id="element-1701" />
    </div>;
}